import {
  getSchedulingSettings,
  setSchedulingAdminEmailAssigned
} from './services/schedulingSettingsService';

const SCHEDULING_ADMIN_PERMISSION_ID = 'scheduling-admin';

const getSchedulingAdminAssignments = async () => {
  const settings = await getSchedulingSettings(false);
  return settings.schedulingAdminEmails || [];
};

const setSchedulingAdminAssignment = async ({ email, assigned, updatedBy }) => (
  setSchedulingAdminEmailAssigned(email, assigned, updatedBy)
);

const schedulingAdminPermission = {
  id: SCHEDULING_ADMIN_PERMISSION_ID,
  moduleId: 'scheduling',
  moduleLabel: 'Scheduling',
  label: 'Scheduling Admin',
  description: 'Can create, edit, delete, assign, and manage scheduling shifts.',
  getAssignments: getSchedulingAdminAssignments,
  setAssignment: setSchedulingAdminAssignment
};

const schedulingAdminPermissions = [
  schedulingAdminPermission
];

export default schedulingAdminPermissions;
